import { Icons } from '@/app/components/ui/Icons'
import { FC } from 'react'
import { CircleFlag } from 'react-circle-flags'

interface SelectorButtonProps {
	flagCode: string
	title: string
	subtitle: string
	isOpen: boolean
	onClick: () => void
	ariaControls: string
}

const SelectorButton: FC<SelectorButtonProps> = ({
	flagCode,
	title,
	subtitle,
	isOpen,
	onClick,
	ariaControls,
}) => {
	return (
		<button
			className="px-3 py-4 mt-2 bg-white rounded-2xl w-full flex items-center justify-between"
			onClick={onClick}
			aria-expanded={isOpen}
			aria-controls={ariaControls}
		>
			<div className="flex items-center">
				<CircleFlag
					countryCode={flagCode.toLowerCase()}
					className="h-6 w-6 me-4"
					aria-hidden="true"
				/>
				<div className="flex flex-col justify-start items-start">
					<span className="font-semibold leading-[18px]">{title}</span>
					<span className="text-text-600 text-sm leading-[18px]">
						{subtitle}
					</span>
				</div>
			</div>
			<Icons.caret
				className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
				aria-hidden="true"
			/>
		</button>
	)
}

export default SelectorButton
